import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=de89f74e&scoped=true&"
import script from "./Menus.vue?vue&type=script&lang=js&"
export * from "./Menus.vue?vue&type=script&lang=js&"
import style0 from "./Menus.vue?vue&type=style&index=0&id=de89f74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de89f74e",
  null
  
)

export default component.exports